import React, { useEffect } from 'react';
import { Carousel, Col, Container, Row, Button } from 'react-bootstrap';
import image1 from "../images/a.png"
import image2 from '../images/b.png'
import image3 from '../images/3.png'
import image4 from '../images/4.png'
import image5 from '../images/5.png'
import image6 from '../images/t1.png'
import image7 from '../images/t2.png'
import image8 from '../images/t3.png'
import image9 from '../images/t4.png'
import image10 from '../images/t5.png'
import ecommerce1 from '../images/ecommerce1.png'
import ecommerce2 from '../images/ecommerce2.png'
import ecommerce3 from '../images/ecommerce3.png'
import ecommerce4 from '../images/ecommerce4.png'
import ecommerce5 from '../images/ecommerce5.png'
import ecommerce6 from '../images/ecommerce6.png'
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Projects = () => {

    useEffect(() => {
        AOS.init();
    })
    return (
        <div className="container my-5">
            <div className="title">
                <h2 className="my-4"> <span className="title-color">Some of</span>  my projects</h2 >
                <hr className="w-25" />
                <div style={{ marginLeft: '-30px' }}>
                    <Link to="/allProjects">
                        <Button variant="outline-success">All Projects</Button>{' '}
                    </Link>
                </div>

            </div>

            <div className="my-4">
                <Container>
                    <div data-aos="" data-aos-duration="2000" className="my-4 p-4 rounded" style={{ backgroundColor: 'rgb(23, 42, 69', }}>
                        <Row xs={1} md={2} className="align-items-center" >
                            <Col className="md-col-6 sm-col-12" >
                                <Carousel fade>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce1}
                                            alt="First slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce2}
                                            alt="First slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce3}
                                            alt="Second slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce4}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce5}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={ecommerce6}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </Col>
                            <Col>
                                <div className="rounded pb-5">
                                    <p>01</p>
                                    <h2>E-commerce website</h2>
                                    <p> This is a dynamic E-commerce website that has our daily necessary goods. After login, user can buy a products and can give review for this application. In admin panel, admin can manage all products and orders and also can make admin anyone.</p>
                                    <div>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">React.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Node.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Express.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Tailwind CSS</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Firebase</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Redux</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Axios</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Heroku</Button>

                                    </div>
                                    <div className="mt-3">
                                        <span> <a style={{ fontSize: '-10px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/e-commerce-website-client"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                        <span> <a style={{ fontSize: '30px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://e-commerce-website-b91ec.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <div data-aos="" data-aos-duration="2000" className="my-4 p-4 rounded" style={{ backgroundColor: 'rgb(23, 42, 69', }}>
                        <Row xs={1} md={2} className="align-items-center" >
                            <Col className="md-col-6 sm-col-12" >
                                <Carousel fade>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image1}
                                            alt="First slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image2}
                                            alt="Second slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image3}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image4}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image5}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </Col>
                            <Col>
                                <div className="rounded pb-5">
                                    <p>02</p>
                                    <h2>Moto Bike Store</h2>
                                    <p>A dynamic bike store website where users can order any product after login and can view their ordered products after placing the order and can place review. Admin can add and delete products and also can change ordered status and can make admin anyone.Sign up and sign in via email through firebase authentication. </p>
                                    <div>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">React.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Node.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Express.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Firebase</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Heroku</Button>

                                    </div>
                                    <div className="mt-3">
                                        <span> <a style={{ fontSize: '-10px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/bike-selling-client"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                        <span> <a style={{ fontSize: '30px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://bike-selling-client.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </div>


                    {/* 3nd projects */}


                    <div data-aos="" data-aos-duration="2000" className="my-4 p-4 rounded" style={{ backgroundColor: 'rgb(23, 42, 69', }}>
                        <Row xs={1} md={2} className="align-items-center" >
                            <Col >
                                <Carousel fade>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image6}
                                            alt="First slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image7}
                                            alt="Second slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image8}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image9}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                    <Carousel.Item>
                                        <img
                                            className="d-block w-100"
                                            src={image10}
                                            alt="Third slide"
                                            style={{ height: '300px' }}
                                        />
                                    </Carousel.Item>
                                </Carousel>

                            </Col>
                            <Col>
                                <div className="rounded pb-5">
                                    <p>03</p>
                                    <h2>Hotel Booking</h2>
                                    <p> Tourism can see about so many hotel and also can book a hotel as their preferred place. Admin can shifted their order and then they can inform others guidlines about this hotel and place.</p>
                                    <div>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">React.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Node.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Express.js</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">MongoDB</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Bootstarp4</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Firebase</Button>
                                        <Button className="me-2 mt-2" variant="secondary" size="sm">Heroku</Button>

                                    </div>

                                    <div className="mt-3">
                                        <span> <a style={{ fontSize: '-10px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://github.com/aktarinaakhi/tourism-booking-website"><i style={{ fontSize: '25px' }} className="fab fa-github-square"></i></a></span>

                                        <span> <a style={{ fontSize: '30px', color: '#64ffda', marginRight: '20px' }} target="_blank" rel="noreferrer" href="https://tourism-assignment-11.web.app/"><i style={{ fontSize: '20px' }} className="fas fa-external-link-alt"></i></a></span>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </div>

                </Container>

            </div>


        </div>


    );
};

export default Projects;